import type { IStoriesFolder } from "@/shared/types";
import { reactQueryUtils } from "@lib/react-query";
import { useQuery } from "@tanstack/react-query";
import { foldersApi } from "./folders.api";
import { foldersKeys } from "./folders.keys";

export const useGetFoldersQuery = (options = {}) => {
  return useQuery({
    queryKey: foldersKeys.folders,
    queryFn: () => foldersApi.getFolders(),
    ...options,
  });
};

export const useLazyGetFoldersQuery = () => {
  return {
    query: async (omitCache?: boolean) => {
      if (!omitCache) {
        const cache = reactQueryUtils.getQueryData<IStoriesFolder[]>([
          ...foldersKeys.folders,
        ]);
        if (cache) return cache;
      }
      const data = await foldersApi.getFolders();
      reactQueryUtils.setQueryData([...foldersKeys.folders], data);
      return data;
    },
  };
};

export const useGetFolderByIdQuery = (id: string, enabled = true) => {
  return useQuery({
    queryKey: foldersKeys.folder(id),
    queryFn: () => foldersApi.getFolderById(id),
    enabled: enabled && !!id,
  });
};
